import { Formik, FormikHelpers } from "formik";
import {
  IdentityMelcoModelsProductListItem,
  useFormSubmit,

} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import * as Yup from "yup";
import { DisplayEditProductForm } from "./DisplayEditProductForm";
import { useEditProduct } from "../../../hooks/product/useEditProduct";

export type SubmitAction = "edit";

export type EditProductFormValueInterface = {
  code: string;

  name: string;
  description: string;
  app_startup_endpoint: string;
  auto_login_endpoint: string;
  legal_policy_version: number;
  is_demo_available: string;
  is_internal: string;
  account_verification_required: string;
  security_type: string;
  devices_allowed: number;
  max_devices_allowed: number;
  offline_seconds_allowed: number;
  seconds_to_relogin: number;
  send_notification_emails: string;
};

type EditProductFormProps = {
  referenceDrawer: DrawerType;
  onCloseDrawer: (closeDrawer: boolean) => void;
  ProductDetails: IdentityMelcoModelsProductListItem;
};

export const EditProductForm: React.FC<EditProductFormProps> = ({
  referenceDrawer,
  onCloseDrawer,
  ProductDetails,
}) => {
  const { t } = useTranslation();
  //const token = useUserToken();
  const editProduct = useEditProduct();

  const onSubmit = async (
    values: EditProductFormValueInterface,
    formikHelpers: FormikHelpers<EditProductFormValueInterface>
  ) => {
    console.log("SUBMIT");
    console.log(values);

    await onEditNewProduct(values, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const handleEditProduct = async (
    values: EditProductFormValueInterface,
    formikHelpers: FormikHelpers<EditProductFormValueInterface>,
    options: {}
  ) => {
    const response = await editProduct({ ...values });
    if (response?.success) {
      formikHelpers.resetForm();
      onCloseDrawer(false);
    }
  };

  const formSubmitToEditNewProduct = () => {
    console.log("777777777");

    return [
      async (
        values: EditProductFormValueInterface,
        formikHelpers: FormikHelpers<EditProductFormValueInterface>
      ) => {
        console.log("85");
        return handleEditProduct(values, formikHelpers, {});
      },
      {
        translationOptions: {
          batchNumber: 1,
        },
        translationPrefix: ["products_list.edit.drawer.actions", "update"].join(
          "."
        ),
        onError: () => {
          // refetch entity from server
          //  queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onEditNewProduct = useFormSubmit(...formSubmitToEditNewProduct());

  const initialValues: EditProductFormValueInterface = {
    code: ProductDetails.code ? ProductDetails.code : "",
    name: ProductDetails.name ? ProductDetails.name : "",
    description: ProductDetails.description ? ProductDetails.description : "",
    app_startup_endpoint: ProductDetails.app_startup_endpoint
      ? ProductDetails.app_startup_endpoint
      : "",
    auto_login_endpoint: ProductDetails.auto_login_endpoint
      ? ProductDetails.auto_login_endpoint
      : "",
    legal_policy_version: ProductDetails.legal_policy_version
      ? ProductDetails.legal_policy_version
      : 0,
    is_demo_available: ProductDetails.is_demo_available ? "true" : "false",
    is_internal: ProductDetails.is_internal ? "true" : "false",
    account_verification_required: ProductDetails.account_verification_required
      ? "true"
      : "false",
    security_type: ProductDetails.security_type
      ? ProductDetails.security_type
      : "",
    devices_allowed: ProductDetails.devices_allowed
      ? ProductDetails.devices_allowed
      : 0,
    max_devices_allowed: ProductDetails.max_devices_allowed
      ? ProductDetails.max_devices_allowed
      : 0,
    offline_seconds_allowed: ProductDetails.offline_seconds_allowed
      ? ProductDetails.offline_seconds_allowed
      : 0,
    seconds_to_relogin: ProductDetails.seconds_to_relogin
      ? ProductDetails.seconds_to_relogin
      : 0,
    send_notification_emails: ProductDetails.send_notification_emails
      ? "true"
      : "",
  };

  // const onAddNewProduct = useFormSubmit(...formSubmitToAddNewProduct());

  const EditProductSchema = Yup.object().shape({
    code: Yup.string().required(),
    legal_policy_version: Yup.number().typeError(t("common.number_validation")),
    devices_allowed: Yup.number().typeError(t("common.number_validation")),
    max_devices_allowed: Yup.number().typeError(t("common.number_validation")),
    offline_seconds_allowed: Yup.number().typeError(
      t("common.number_validation")
    ),
    seconds_to_relogin: Yup.number().typeError(t("common.number_validation")),
  });

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={EditProductSchema}
      >
        <DirtyFormPrompt>
          <DisplayEditProductForm
            ProductDetails={ProductDetails}
          ></DisplayEditProductForm>
        </DirtyFormPrompt>
      </Formik>
    </>
  );
};
